/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
// Core imports
import { Navigate, useParams } from "react-router-dom";

// Component imports
import { Flex, Spin } from "antd";
import { Container } from "@/components/UI/Container";

// Misc imports
import { useGetCheckoutStatus } from "@/api/subscriptions";
import { NAV_PROJECT_SINGLE_VIEW, NAV_SUBSCRIPTION_PLANS } from "@/constants";
import replaceUrlParams from "@/utils/string/replaceUrlParams";
import { tokens as Tokens } from "@/utils/tokens";
import { queryClient } from "@/utils/queryClient";
import { ITokens } from "@/interfaces/User.interface";

export const CheckoutReturn = () => {
  const { workspaceId, projectId, checkoutSessionId } = useParams();
  const tokensInstance = Tokens;
  const userAuth:ITokens | undefined = queryClient.getQueryData(["user-auth"]);
  const { access: accessToken } = userAuth || {};
  const { data: checkoutStatus, isLoading: isFetchingCheckoutStatus } = useGetCheckoutStatus(tokensInstance.getTokenSub(accessToken) as string, checkoutSessionId as string);

  if (isFetchingCheckoutStatus) {
    return(
      <Container>
        <Flex justify="center">
          <Spin />
        </Flex>
      </Container>
    )
  }

  if (checkoutStatus?.status === "open" || checkoutStatus?.status === "expired") {
    return (
      <Navigate
        to={replaceUrlParams(NAV_SUBSCRIPTION_PLANS, {
          workspaceId: workspaceId as string,
          projectId: projectId as string,
        })}
        replace
      />
    );
  }

  if (checkoutStatus?.status === "complete") {
    return (
      <Navigate
        to={replaceUrlParams(NAV_PROJECT_SINGLE_VIEW, {
          workspaceId: workspaceId as string,
          projectId: projectId as string,
        })}
        state={checkoutStatus}
        replace
      />
    )
  }

  return null;
};
